import { render, staticRenderFns } from "./MultiPointBasicInfoEditor.vue?vue&type=template&id=1b43b8d4&"
import script from "./MultiPointBasicInfoEditor.vue?vue&type=script&lang=ts&"
export * from "./MultiPointBasicInfoEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports